import { Component, ElementRef, Inject, OnInit } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { JobsService } from 'src/app/core/services/jobs.service';
import { MatSnackBar } from '@angular/material/snack-bar'; 

@Component({
  selector: 'app-run-job-command',
  templateUrl: './run-job-command.component.html',
  styleUrls: ['./run-job-command.component.scss']
})
export class RunJobCommandComponent implements OnInit {

  jobForm: UntypedFormGroup;
  headerText: string = "";
  showOutputDialog: boolean = false;
  submitButtonText: string = "";
  jobOutput: string = "";
  dataEmpty: boolean = false;
  regexCode: string = "gi";
  searchTerm: string;
  totalWordCount: number = 0;
  curvalue: number = 0;
  currentWordIndex: number = 0;
  totalElements: number;
  findExppr;
  autoScroll: boolean = false;
  isSensitiveTitle: string = "case-insensitive";
  isSensitive: boolean = false;
  toogleDialog: boolean = false;

	constructor(
		public dialog: MatDialogRef<RunJobCommandComponent>,
		@Inject(MAT_DIALOG_DATA)
		public data: {
			depName: string;
			jobName: string;
			actionText: string;
      actionValue: number;
      runCommandFromJobActions: boolean;
      id: string;
		},
    public jobService: JobsService,
    private spinner: NgxSpinnerService,
    private myElement: ElementRef,
    private snackBar: MatSnackBar 
  ) { }

  ngOnInit() {
    if (this.data?.runCommandFromJobActions) {
      this.headerText = "Run Command in Job Directory";
      this.showOutputDialog = false;
      this.submitButtonText = "Submit";
    }
    else {
      this.headerText = "Run Command";
      this.submitButtonText = "Run";
      this.showOutputDialog = true;
    }
		this.jobForm = new UntypedFormGroup({
			command_jobCommand: new UntypedFormControl(null, Validators.required),
		});
	}

	onCancel() {
		this.dialog.close();
	}

  onSubmit(form) {
    this.jobOutput = "";
    let exitSubmit: boolean = false;
    if (this.jobForm.value.command_jobCommand != null) {
      let forbiddenCommands = ["restart", "reboot", "shutdown", "poweroff"]
      forbiddenCommands.forEach(commands => {
        if (this.jobForm.value.command_jobCommand.includes(commands)) {
          this.jobOutput = "Cannot Input Commands :- 'reboot','shutdown', 'poweroff', 'restart'";
          exitSubmit = true;
        }
      })
    }

    if (exitSubmit) { return }

    if (this.data?.runCommandFromJobActions) {
      this.dataEmpty = false;
      if (this.jobForm.value.command_jobCommand !== null) {
        try {
          let newCommand = this.jobForm.value.command_jobCommand;
          this.jobService.triggerAnActionForJob(
            this.data.depName,
            this.data.jobName,
            this.data.actionText,
            this.data.actionValue,
            "false",
            "",
            newCommand
          ).subscribe({
            next: () => {
              this.snackBar.open('Run Command request sent successfully', 'Close', {
                duration: 3000
              });
              this.dialog.close();
            },
            error: (error) => {
              this.snackBar.open('Failed to send Run Command request', 'Close', {
                duration: 3000
              });
            }
          });
          this.dialog.close();
        } catch (e) {
        }
      } else {
        form.controls.command_jobCommand.touched = true;
      }
    }
    else {
      this.spinner.show();
      if (this.jobForm.value.command_jobCommand !== null) {
        try {
          let newCommand = this.jobForm.value.command_jobCommand;
          this.jobService.triggerAnActionForJob(
            this.data.depName,
            "",
            this.data.actionText,
            this.data.actionValue,
            "false",
            "",
            newCommand
          ).subscribe({
            next: (data) => {
              if (data) {
                data = JSON.parse(JSON.stringify(data?.message));
                this.jobOutput = data;
                this.spinner.hide();
              }
              else {
                this.spinner.hide();
                this.dataEmpty = true;
              }
            },
            error: error => {
              this.spinner.hide();
              this.jobOutput = "Some error occurred... Please try again!";
            }
          });
        } catch (e) {
          this.spinner.hide();
          this.jobOutput = "Some error occurred... Please try again!";
        }
      } else {
        this.spinner.hide();
        this.dataEmpty = true;
        form.controls.command_jobCommand.touched = true;
      }
    }
  }

  removeAttrrStyle(dom) {
    dom.querySelectorAll(".marked")[this.curvalue].setAttribute("style", "background-color: #fcf8e3");
  }

  toogleDialogMinMax() {
    if (this.toogleFullScreen && !this.toogleDialog) {
      this.onFullScreen();
    }
    if (this.toogleDialog == false) {
      this.toogleDialog = true;
      let element = document.getElementById(this.data.id);
      element.classList.add("minimize2");
    } else {
      this.toogleDialog = false;
      let element = document.getElementById(this.data.id);
      element.classList.remove("minimize2");
    }
  }

  toogleFullScreen: boolean = false;
  onFullScreen() {
    if (this.toogleDialog) {
      this.toogleDialogMinMax();
    }
    let element = document.querySelector(".run-command-dialog");
    if (!this.toogleFullScreen) {
      element.classList.add("fullScreen");
    } else {
      element.classList.remove("fullScreen");
    }
    this.toogleFullScreen = !this.toogleFullScreen;
  }
}
